import axios from 'axios'
import { Decode } from '@/services'

const GetToken = () => {
  if (localStorage.getItem('authNSG') !== null) {
    const oneData = JSON.parse(Decode.decode(localStorage.getItem('authNSG')))
    const auth = {
      headers: { Authorization: `Bearer ${oneData.user.access_token}` }
    }
    return auth
  } else {
    const auth = ''
    return auth
  }
}

export default {
  async SaleManDetail (val) {
    const data = val
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}sale_man_detail`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ListAllSaleMan (val) {
    const data = val
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}position/list_all_sale_man`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ListCustomerForSaleMan () {
    const auth = await GetToken()
    try {
      var response = await axios.get(`${process.env.VUE_APP_BACK_END}order/list_customer`, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ListOrderSaleMan (val) {
    const data = val
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}list_order_saleman`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }
}
